import { initializeApp, FirebaseOptions } from 'firebase/app'
import { isSupported, getMessaging, getToken, onMessage } from 'firebase/messaging'


class WebPushNotification {


    constructor() {
        this.WEB_PUSH_DELAY = 7 * 1440 * 1000; //семь дней
        this.initApplication();
    }

    async initApplication(){
        const supported = await isSupported().catch(() => false);
        if (!supported) {
            return null;
        }

        this.webPushModalNotification = document.querySelector('[web-push-notification-form]');
        if(this.webPushModalNotification){
            this.webPushModalNotification.addEventListener('click', this.onClickWebPushModalNotificationListener.bind(this));
        }


        this.sw = await window.navigator.serviceWorker.register('/firebase-messaging-sw.js');

        this.application  = initializeApp({
            apiKey: "AIzaSyDQOkFGMkyDQ_pMXLRlv_k6v4OX9sBZJzY",
            authDomain: "dev-diapazon-kz.firebaseapp.com",
            projectId: "dev-diapazon-kz",
            storageBucket: "dev-diapazon-kz.appspot.com",
            messagingSenderId: "671652069116",
            appId: "1:671652069116:web:76d244ac845e5621876179",
            measurementId: "G-KZ6RLRSGSE"
        })
        this.messaging = getMessaging(this.application)

        if (Notification.permission !== "granted") {
            if(localStorage.getItem('web-push-delay') === null || Date.now() > Number.parseInt(localStorage.getItem('web-push-delay'))){
                setTimeout( () => {
                    this.webPushModalNotification.classList.add('-active');
                }, 3000);
            }
        }else{
            await this.getToken();
        }

       onMessage(this.messaging, (payload) => {
            new Notification(payload.notification.title, {body: payload.notification.body, icon: '/img/icons/apple-touch-icon-60x60.png' });
        });
    }
    async getToken(){
        const token = await getToken( this.messaging , {
            serviceWorkerRegistration: this.sw
        });

        await fetch('/api/web-push/token', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({token: token})})
            .then((response) =>  response.json());
    }

    async onClickWebPushModalNotificationListener(event){

        const target = event.target;
        if(target instanceof HTMLButtonElement){
            this.webPushModalNotification.classList.remove('-active')

            if(target.dataset.pushButton === 'reject'){
                localStorage.setItem('web-push-delay', (Date.now() + this.WEB_PUSH_DELAY))
            }
            if(target.dataset.pushButton === 'success'){
                Notification.requestPermission().then(async (permission) => {
                    if (permission === "granted") {
                        await this.getToken();
                    }


                });
            }
        }

    }
}
new WebPushNotification();

